import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({ Company, WorkOrder }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">More Information</p>
      </div>

      <div className="col-6 ">
        <div className={Company.Error ? `mb-3 errorborder` : `mb-3`}>
           <Input
            id="Company"
            readOnly
            label="Company"
            style={{
              height: "30px",
              border: Company?.Error ? "1px solid red" : "",
            }}
            value={Company?.select_Company || ""}
          />
         
        
         
        </div>
      </div>

      <div className="col-6">
       <div className={WorkOrder.Error ? `mb-3 errorborder` : `mb-3`}>
         <Input
            id="WorkOrder"
            readOnly
            label="WorkOrder"
            style={{
              height: "30px",
              border: WorkOrder?.Error ? "1px solid red" : "",
            }}
            value={WorkOrder?.select_WorkOrder || ""}
          />

         
        </div>
      </div>
    </div>
  );
};

export default Tab3;